<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { ElMessageBox } from 'element-plus'

const AGE_GATE_STORAGE_KEY = 'novel_age_gate_ack_v1'

export default {
  name: 'App',
  setup() {
    const route = useRoute()
    const router = useRouter()
    const { t } = useI18n()

    onMounted(async () => {
      await router.isReady()
      if (route.path.startsWith('/admin')) return
      if (localStorage.getItem(AGE_GATE_STORAGE_KEY)) return
      try {
        await ElMessageBox.confirm(t('ageGate.body'), t('ageGate.title'), {
          type: 'warning',
          confirmButtonText: t('ageGate.confirm'),
          cancelButtonText: t('ageGate.leave'),
          closeOnClickModal: false,
          closeOnPressEscape: false,
          showClose: false,
          distinguishCancelAndClose: true
        })
        localStorage.setItem(AGE_GATE_STORAGE_KEY, '1')
      } catch {
        window.location.replace('about:blank')
      }
    })

    return {}
  }
}
</script>
